export type ScoringSex = 'male' | 'female';

export interface UserProfile {
  id: string;
  normalizedEmail: string;
  displayName: string;
  bodyWeightLb: number;
  scoringSex: ScoringSex;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateProfileInput {
  email: string;
  displayName: string;
  bodyWeightLb: number;
  scoringSex: ScoringSex;
}

export interface UpdateProfileInput {
  displayName?: string;
  bodyWeightLb?: number;
  scoringSex?: ScoringSex;
}

export interface BodyWeightRecord {
  id: string;
  userId: string;
  bodyWeightLb: number;
  effectiveAt: Date;
  createdAt: Date;
}

/** Normalize email: trim whitespace and lowercase */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** Validate body weight is within acceptable range */
export function isValidBodyWeight(weight: number): boolean {
  return Number.isInteger(weight) && weight >= 50 && weight <= 700;
}

/** Validate display name */
export function isValidDisplayName(name: string): boolean {
  return name.trim().length > 0 && name.trim().length <= 100;
}

/** Validate email format (basic check) */
export function isValidEmail(email: string): boolean {
  const normalized = normalizeEmail(email);
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
}
